import React from 'react';
import { View } from '@react-pdf/renderer';
import { styles } from './PDFStyles.style';

const List: React.FC = ({ children }) => {
  return <View style={{ ...styles.list, ...styles.fonts, ...styles.paragraph }}>{children}</View>;
};

export default List;
